import Vue from 'vue';
import {helpers} from './../../helpers';

export default {
    store: {
        namespaced: true,
        state: {
            endpoint: 'finance',
            operations: [],
            debtors: [],
            sum: {
                coming: 0,      //приход
                consumption: 0, //расход
                sum: 0          //сумма
            },
        },
        actions: {
            getOperations({state, rootState}, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/finance', {params: data}).then(r => {
                    if (!r) return [];
                    Vue.set(state, 'operations', r.data);
                    Vue.set(state, 'operations_amount', r.total);
                    return r.data;
                });
            },

            getOperation({ state, rootState }, options) {
                return helpers.http.get({context: this, rootState}, '/finance/byid/' + options.operationId).then(r => {
                    Vue.set(state, 'operation', r);
                    return r;
                });
            },

            postOperation({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/finance', data);
            },

            putOperation({ rootState }, data){
                return helpers.http.put({context: this, rootState}, '/finance', data);
            },

            removeOperation({ rootState }, id){
                return helpers.http.delete({context: this, rootState}, '/finance/byid/' + id);
            },

            removeOperationFile({ rootState }, data){
                return helpers.http.delete({context: this, rootState}, '/finance/file', data);
            },

            calculation({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/finance/calc', {params: data}).then(r => {
                    state.sum = r;
                    return r;
                });
            },

            getDebt({ rootState }, data) {
                return helpers.http.get({context: this, rootState}, '/finance/debt/customer/' + data.id);
            },

            getDebtByDeal({ rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/finance/debt/deal/' + id + '?debug=true');
            },

            getDebtors({ state, rootState }) {
                return helpers.http.get({context: this, rootState}, '/debtors').then(r => {
                    Vue.set(state, 'debtors', r);
                    return r;
                });
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/finance/store.js